export default new class mobileLocation {
    constructor() {
        this.location = '[data-location]';
        this.activeClass = 'mobile-location__item_active';

        if (!$(this.location).length) {
            return;
        }

        this.bindEvents();
    }

    bindEvents() {
        $(document).on('click', this.location, (e) => {
            let $currentItem = $(e.target);

            if ($currentItem.hasClass(this.activeClass)) {
                return;
            }

            $(this.location).removeClass(this.activeClass);
            $currentItem.addClass(this.activeClass);


            console.log($(e.target).attr('data-location'));
        });
    }
};


// WEBPACK FOOTER //
// ./src/common/modules/mobile-location/mobile-location.js